/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetPlatformBalancesResponse { 
    totalBalance: number;
    totalPendingPayout: number;
    totalPayoutsApproved: number;
    currency: string;
    lastUpdatedAt: string;
}

